export default __webpack_public_path__ + "static/media/success.7ecbd3ab.png";